import _defineProperty from '@babel/runtime/helpers/defineProperty';
import '../../../../../../util/styles/index.js';
import { mergeProps } from '@react-aria/utils';
import { TEXTAREA_CONTAINER_DEFAULT_STYLES, RESIZE_VALUE_MAP } from '../../constants.js';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Hook to manage the styles of the Textarea container.
 * It handles the disabled state, resize options, and min/max height.
 * It returns the container styles and props to be applied to the Textarea component.
 */
var useTextareaContainerStyles = function useTextareaContainerStyles(_ref) {
  var disabled = _ref.disabled,
    resize = _ref.resize,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles,
    getInteractiveState = _useAdsStyles.getInteractiveState;

  // Base container styles
  var containerStyles = mapAdsStyles(_objectSpread(_objectSpread(_objectSpread({}, TEXTAREA_CONTAINER_DEFAULT_STYLES), minHeight ? {
    minHeight: minHeight
  } : {}), maxHeight ? {
    maxHeight: maxHeight
  } : {}));

  // Apply native resize style
  if (resize) {
    containerStyles.style = _objectSpread(_objectSpread({}, containerStyles.style), {}, {
      resize: RESIZE_VALUE_MAP[resize]
    });
  }

  // if `disabled`, return styles without interactive states
  if (disabled) {
    return containerStyles;
  }

  // Merge in hover/focus/active styles only if not disabled
  var interactiveStyles = getInteractiveState({
    type: 'container',
    within: true
  }).adsStyles;
  return mergeProps(containerStyles, interactiveStyles);
};

export { useTextareaContainerStyles };
//# sourceMappingURL=useTextareaContainerStyles.js.map
